/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
import _cloneDeep from 'lodash/cloneDeep';
import { Analytics } from '../../../../analytics/sendAnalyticsEvent';
import { ANALYTICS_PROCESS_PRE_IGNITION_EVENTS_DELAY } from '../../../../constants';
import { generateAnalyticsInteractionEvent } from '../utils/generateAnalyticsInteractionEvent';

// Store action for cabinet collection selection analytics event
export default (set, get, payload) => {
  const { target } = payload;
  set(
    produce(get(), (draft) => {
      if (!draft.digitalData) {
        draft.digitalData = { event: [] };
      }
      const section = 'choose cabinet collection';
      const event = {
        ...generateAnalyticsInteractionEvent(section, typeof target === 'string' ? target.toLowerCase() : undefined),
      };

      const eventClone = _cloneDeep(event);
      draft.digitalData.event.push(event);
      setTimeout(() => {
        Analytics.sendAnalyticsEvent(eventClone);
      }, ANALYTICS_PROCESS_PRE_IGNITION_EVENTS_DELAY);
    }),
    false,
    { type: 'CABINET_COLLECTION_SELECTION_EVENT' }
  );
};
